export default "__VITE_PUBLIC_ASSET__0afa79e9__"